import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/editor/commentary';
import { getCommentsCount } from 'selectors/commentary';
import { pluralize } from 'utils/string_utils';

const CommentaryHeader = ({ count, hideCommentary }) => (
  <div className="Commentary-header">
    <div className="Commentary-commentCount">
      <span
        className="Commentary-title"
        children={
          !count ? 'No Comments' : `${count} ${pluralize(count, 'Comment')}`
        }
      />
      <div className="Commentary-title--secondary">about this element</div>
    </div>
    <button
      type="button"
      className="Commentary-closeButton"
      onClick={hideCommentary}
      children="Hide"
    />
  </div>
);

const mapStateToProps = ({ editor }) => ({
  count: getCommentsCount(editor.commentary),
});

const mapDispatchToProps = {
  hideCommentary: actions.hideCommentary,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentaryHeader);
